import { styled } from "styled-components";

export const PageHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 6px 20px;

	.button_group {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 18px;
	}

	img {
		padding: 0 6px;
		transform: scale(0.85);
	}
	button {
		border-radius: 5px;
		padding: 6px 18px;
	}
`;

export const ParametersWrapper = styled.div`
	color: #333333;
	font-weight: 500;
	margin-top: 2.5rem;

	.parametersList {
		margin-top: 12px;

		.heading {
			width: fit-content;
			padding: 15px 24px;
			border-radius: 6px;
			background: #f5f5f5;
			margin-bottom: 22px;
		}

		.listItem {
			color: #555;
			padding: 12px 4px;
			position: relative;
			display: grid;
			align-content: center;

			&.col-last {
				left: -28px;
			}
			.editButton {
				width: fit-content;
				height: fit-content;
				display: flex;
				align-items: center;
				gap: 8px;
				transform: scale(0.85);
			}
		}

		.actions button {
			padding-left: 36px;
			padding-right: 36px;
		}
	}
`;
